import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const APP_STORE_URL = 'https://apps.apple.com/app/eranos/id6744076552';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.eranos.app';
const CUSTOM_SCHEME = 'eranos://';

function getDeviceType() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  if (/android/i.test(ua)) return 'android';
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';
  return 'desktop';
}

export default function DeepLink() {
  const { type, code } = useParams();
  const [showFallback, setShowFallback] = useState(false);
  const device = getDeviceType();
  const deepPath = `${type}/${code}`;
  const universalLink = `https://www.geteranos.com/${deepPath}`;
  const customSchemeLink = `${CUSTOM_SCHEME}${deepPath}`;

  useEffect(() => {
    // On iOS, universal links should handle it automatically when the user
    // tapped a link to get here. As a fallback, try the custom scheme.
    // On Android, try the intent URL first, then fall back.
    if (device === 'ios') {
      window.location.href = customSchemeLink;
    } else if (device === 'android') {
      const intentUrl = `intent://${deepPath}#Intent;scheme=eranos;package=com.eranos.app;end`;
      window.location.href = intentUrl;
    }

    const timer = setTimeout(() => {
      setShowFallback(true);
    }, 2500);

    return () => clearTimeout(timer);
  }, [device, deepPath, customSchemeLink]);

  const storeUrl = device === 'android' ? PLAY_STORE_URL : APP_STORE_URL;
  const storeName = device === 'android' ? 'Google Play' : 'App Store';

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#1a1a2e',
      color: '#ffffff',
      fontFamily: "'Inter', sans-serif",
      padding: '24px',
      textAlign: 'center',
    }}>
      <h1 style={{
        fontFamily: "'Pacifico', cursive",
        fontSize: '2.5rem',
        marginBottom: '24px',
        color: '#f5a623',
      }}>
        Eranos
      </h1>

      {!showFallback ? (
        <div>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid rgba(245, 166, 35, 0.3)',
            borderTopColor: '#f5a623',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px',
          }} />
          <p style={{ fontSize: '1.1rem', opacity: 0.9 }}>Opening in the Eranos app...</p>
        </div>
      ) : (
        <div>
          <p style={{ fontSize: '1.1rem', marginBottom: '24px', opacity: 0.9 }}>
            {device === 'desktop'
              ? 'Scan this link on your phone to open in the Eranos app.'
              : "Looks like you don't have the app installed yet."}
          </p>

          {device !== 'desktop' && (
            <a
              href={storeUrl}
              style={{
                display: 'inline-block',
                padding: '14px 32px',
                background: '#f5a623',
                color: '#1a1a2e',
                borderRadius: '12px',
                textDecoration: 'none',
                fontWeight: 600,
                fontSize: '1rem',
                marginBottom: '16px',
              }}
            >
              Download from {storeName}
            </a>
          )}

          {device !== 'desktop' && (
            <p style={{ marginTop: '16px', opacity: 0.6, fontSize: '0.85rem' }}>
              Already have the app?{' '}
              <a href={customSchemeLink} style={{ color: '#f5a623', textDecoration: 'underline' }}>
                Try opening again
              </a>
            </p>
          )}
        </div>
      )}

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
